import {Component} from '@angular/core';
import {BaseComponent} from "../../views/base.component";
import {EventsService} from "../../lib/EventsService";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "../../translate";
import {FilterFormService} from "../../views/filter_form/filter_form.service";
import {AccessorService} from "./accessor.service";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

import dictionary from "dict/static.json";

import 'selectize/dist/css/selectize.css';
import 'selectize/dist/js/standalone/selectize.min.js';
import {ModalService} from "../../views/modal/base_modal.component";
import {AccessorStatsModalComponent} from "./stats.component";
import {AccessorMyStatsModalComponent} from "./mystats.component";
import {ChartParams} from "../../views/chart/chart.component";
import {AccessorPersonalStatsModalComponent} from "./personal_stats.component";
import {AuthService} from "../../auth.service";
import {AccessorManageModalComponent} from "./manage.component";
import {AccessorSiteStatsModalComponent} from "./site_stats.component";
import {AlertComponent} from "../../views/modal/alert.component";

@Component({
	selector: 'accessor',
	templateUrl: './accessor.component.html'
})
export class AccessorComponent extends BaseComponent {
	siteId: string = '';
	url: string = '';	
	safeUrl: SafeResourceUrl;
	domainUrl: string = '';
	userRoles: string[] = [];

	addFilterParams = {
		dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated']
	};
	
	editCount: number = 0;
	deferCount: number = 0;
	totalCount: number = 0;
	
	dictionary: any;
	
	siteCategory: string = '';
	siteSubject: string = '';
	
	topSite: boolean = false;

	selectize = {
		config: {
			valueField  : 'title',
			labelField  : 'title',
			searchField : 'title',
			load: null
		},
		options: []
	};
	
	iframeLoader: boolean = true;
	mainLoader: boolean = true;
	
	height: number = 150;
	
	config;

	selectizeTitle: string;
	
	constructor(public eventsService: EventsService,
				public service: AccessorService,
				public activatedRoute: ActivatedRoute,
				public translate: TranslateService,
				public router: Router,
				public filter: FilterFormService,
				public modalService: ModalService,
				public authService: AuthService,
				private sanitizer: DomSanitizer
	) {
		super(eventsService, service, activatedRoute, filter,translate);

		this.dictionary = dictionary;
	}
	
	onload() {
		var w = window,
			d = document,
			e = d.documentElement,
			g = d.getElementsByTagName('body')[0],
			y = w.innerHeight|| e.clientHeight|| g.clientHeight;

		this.height = y - 160;
	}

	async ngOnInit() {
		this.selectize.options = this.dictionary.accessorCategories;
		this.userRoles         = this.authService.roles;
		
		await this.getIframeData();
		await this.getMainData();
	}
	
	async getConfig() {
		this.config = await this.service.getConfig().toPromise();
	}
	
	async getIframeData() {
		this.iframeLoader = true;
		
		let data: any = await this.service.getIframeInfo().toPromise();

		this.siteId    = data.siteId;
		this.url       = data.url;
		this.domainUrl = data.domainUrl;

		this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://ukit.com/preview/${this.url}/index`);
		
		this.iframeLoader = false;
	}

	async getMainData() {
		this.mainLoader = true;
		
		let data: any = await this.service.getMainInfo(this.filter.filterParams).toPromise();

		this.editCount  = data.editCount;
		this.deferCount = data.deferCount;
		this.totalCount = data.totalCount;
		
		this.mainLoader = false;
	}
	
	async setCategory(defer: number) {
		let check: any = await this.service.checkSite({ siteId: this.siteId }).toPromise();
		if (check.status == 'error') {
			this.modalService.open(AlertComponent, {
				title: 'ERROR',
				message: this.translate.__A('support.accessor.site is editing now')
			});
			return true;
		}
		
		if (defer == 0 && (this.siteSubject == '' || this.siteCategory == '')) {
			this.modalService.open(AlertComponent, {
				title: 'ERROR',
				message: this.translate.__A('support.accessor.set category or defer')
			});
			return true;
		}

		
		let data: any = {
			siteId: this.siteId,
			category: this.siteCategory,
			subject: this.siteSubject,
			defer: defer,
			top: this.topSite
		};
		
		await this.service.setCategory(data).toPromise();
		
		this.topSite  = false;
		
		this.siteCategory   = '';
		this.siteSubject    = '';
		this.selectizeTitle = '';
		
		if (defer) {
			this.deferCount++;
		} else {
			this.editCount++;
		}
		
		this.totalCount--;

		await this.getIframeData();
	}

	async showDetails() {
		let me = this;
		
		const modalRef = this.modalService.open(AccessorStatsModalComponent, {
			title: this.translate.__A('support.accessor.stats'),
		}, {size: 'hg'});
		
		modalRef.componentInstance.chart = new ChartParams();

		modalRef.componentInstance.chart.showLoader();

		const { stats } = await this.service.getStats({}).toPromise();

		modalRef.componentInstance.chart.data = stats.reduce(function(accessors, accessor) {
			accessors.push(
				[
					accessor.email,
					accessor.totalCount
				]
			);
			return accessors;
		}, []);

		modalRef.componentInstance.stats = stats;

		modalRef.componentInstance.chart.setOptions({
			type : 'pie',
			onclick : async function(e) {
				const subModalRef = me.modalService.open(AccessorPersonalStatsModalComponent, {
					title: e.name,
					email: e.name
				}, {size: 'hg'});


				let options = { accessorEmail: e.name, dateFilter: me.filter.filterParams.accessorDateFilter.type, start: me.filter.filterParams.accessorDateFilter.start, end: me.filter.filterParams.accessorDateFilter.end };
				const { stats } = await me.service.getPersonalStats(options).toPromise();
				subModalRef.componentInstance.stats = stats;
			}
		});

		modalRef.componentInstance.chart.hideLoader();
		
	}
	
	async showMyEditSites(type: string) {
		const modalRef = this.modalService.open(AccessorMyStatsModalComponent, {
			title: this.translate.__A(`support.accessor.${type == 'edit' ? 'viewed' : 'defer'} by me`),
			mark: type
		}, {size: 'hg'});

		const { stats } = await this.service.getMyStats({ mark: type }).toPromise();
		modalRef.componentInstance.stats = stats;

		modalRef.componentInstance.getIframeData.subscribe(async ($event) => { await this.getIframeData(); });
	}
	
	async manage() {
		await this.getConfig();
		this.modalService.open(AccessorManageModalComponent, {
			title: this.translate.__A('common.Manage'),
			config: this.config,
		}, {size: 'hg'});
	}
	
	async siteSearch() {
		this.modalService.open(AccessorSiteStatsModalComponent, {
			title: this.translate.__A('support.accessor.site search'),
		}, {size: 'hg'});
	}

	changeSiteCategory($event) {
		if ($event == '') return true;
		
		let data     = $event.split(' - ');
		
		this.siteCategory = data[0];
		this.siteSubject  = data[1];
	}
}
